import React, { useEffect } from "react";
import {
  ThemeProvider as NextThemesProvider,
  useTheme,
} from "next-themes";

const FIRST_LOAD_THEME_KEY = "qp-theme-intro-shown";

function FirstLoadThemeTransition() {
  const { setTheme } = useTheme();

  useEffect(() => {
    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    if (sessionStorage.getItem(FIRST_LOAD_THEME_KEY)) {
      return undefined;
    }

    sessionStorage.setItem(FIRST_LOAD_THEME_KEY, "true");

    if (prefersReducedMotion) {
      setTheme("dark");
      return undefined;
    }

    setTheme("light");
    const transitionTimer = window.setTimeout(() => {
      setTheme("dark");
    }, 700);

    return () => window.clearTimeout(transitionTimer);
  }, [setTheme]);

  return null;
}

// Wraps the app with next-themes. Uses the `class` strategy so Tailwind's
// darkMode:["class"] and our CSS variables (:root = light, .dark = dark) work.
export function ThemeProvider({ children }) {
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="light"
      enableSystem={false}
      disableTransitionOnChange={false}
    >
      <FirstLoadThemeTransition />
      {children}
    </NextThemesProvider>
  );
}

export default ThemeProvider;
